import { useParams } from 'react-router-dom'
import "../../styles/pages/Adm/global.adm.styles.css"
import { ButtonCenter } from "../../components/adm/ButtonCenter"
import { useState, useEffect } from "react"
import { fetchGetDatawithID } from '../../../lib/fetchGetDatawithID'
import { fetchUpdateData } from '../../../lib/fetchUpdateData'

export const EditService = () => {
    const { id } = useParams()
    const collectionName = "services"
    /*const [image, setImage] = useState(null)
    const [imagePage, setImagePage] = useState(null)*/
    const [formData, setFormData] = useState({
        position: "",
        name: "",
        link: "",
        shortDescrip: "",
        longDescrip: "",
        imgHome: "",
        imgPage: ""
    })

    useEffect(() => {
        async function fetchData() {
            let data = await fetchGetDatawithID({
                collectionName: collectionName,
                id: id
            })
            setFormData(data)
        }
        fetchData()
    }, [id])

    async function handleSubmit(e) {
        e.preventDefault()
        try {
            await fetchUpdateData({
                id: id,
                data: formData,
                collectionName: collectionName
            })
            alert("Atualizado")
        } catch (error) {
            alert("erro:", error)
        }
    }

    function handleInputChange(e) {
        let { name, value } = e.target
        setFormData((prevClass) => ({ ...prevClass, [name]: value }))
    }

    /*function handleImagemSelecionada(e) {
        if (e.target.files && e.target.files[0]) {
            setImage(e.target.files[0])
        } else {
            setImage(null)
        }
    }

    function handleImagemPageSelecionada(e) {
        if (e.target.files && e.target.files[0]) {
            setImagePage(e.target.files[0])
        } else {
            setImagePage(null)
        }
    }*/

    function createLinkFunc() {
        let { name } = formData
        // Converte todas as letras maiúsculas para minúsculas
        let nameFormatted = name.toLowerCase()
        // Substitui espaços por hífens
        nameFormatted = nameFormatted.replace(/\s+/g, '-')
        setFormData((prevClass) => ({ ...prevClass, link: nameFormatted }))
    }

    return (
        <>
            <ButtonCenter
                homeBtn={true}
                goBackBtn={true}
            />
            <div className="div-adm-center">
                <form className="form-adm" onSubmit={handleSubmit}>
                    Editar Serviço: {id}
                    <div className="edit-service-adm">
                        <img src={formData.imgHome} alt="Imagem" />
                        <img src={formData.imgPage} alt="Imagem" />
                    </div>
                    <div className="box-position">
                        <p>Posição:</p>
                        <input
                            type="number"
                            placeholder="Posição"
                            name="position"
                            onChange={handleInputChange}
                            value={formData.position}
                            min={0}
                        />
                    </div>
                    <input
                        type="text"
                        placeholder="Nome"
                        name="name"
                        onChange={handleInputChange}
                        onBlur={createLinkFunc}
                        value={formData.name}
                    />
                    <textarea
                        placeholder="Descrição curta para Home"
                        name="shortDescrip"
                        onChange={handleInputChange}
                        value={formData.shortDescrip}
                    />
                    <textarea
                        placeholder="Texto Longo para página"
                        name="longDescrip"
                        onChange={handleInputChange}
                        value={formData.longDescrip}
                    />
                    {/*<label>
                        <p> {image ? "Imagem Home Anexada" : "Imagem Home não anexada"} </p>
                        <input type="file" onChange={handleImagemSelecionada} />
                    </label>
                    <label>
                        <p> {imagePage ? "Imagem Page Anexada" : "Imagem Page não anexada"} </p>
                        <input type="file" onChange={handleImagemPageSelecionada} />
                    </label>*/}
                    <button type="submit"> Salvar </button>
                </form>
            </div>
        </>
    )
}